import React, {
  Fragment,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { paginationCountLabel } from '../../utils/helpers';
import { useTranslation } from 'react-i18next';
import AppConstants from '../../AppConstants';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: '60vh',
    minHeight: '55vh',
  },
});
interface TableViewProps {
  columns: any[];
  rows: any[];
  paginationConfig: any;
  handleChangeRowsPerPage: Function;
  handleChangePage: Function;
  messageEmptyArray?: string;
  checkboxes?: boolean;
  checkSelected?: Function;
  clearFlag?: boolean;
  clearSelectedEquipments?: Function;
  padding: number;
  paddingLeft: number;
}

export const TableView = ({
  columns,
  rows,
  paginationConfig,
  handleChangeRowsPerPage,
  handleChangePage,
  messageEmptyArray = '',
  checkboxes = false,
  checkSelected = event => { },
  clearFlag = false,
  clearSelectedEquipments = event => { },
  padding = 0,
  paddingLeft = 0,
}) => {
  const classes = useStyles();
  const [checked, setChecked] = useState({});
  const [masterChecked, setMasterChecked] = useState(false);
  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>, row: any) => {
    setChecked({ ...checked, [event.target.name]: { checked: event.target.checked, data: row } });
  };
  const ref = useRef<any>();

  useLayoutEffect(() => {
    ref?.current?.scrollTo?.({
      top: 0,
      behavior: 'smooth',
    });
  }, [rows]);
  const setAllChecked = value => {
    setChecked({
      ...rows.reduce((ac, c) => {
        ac[c.id] = { checked: value, data: c };
        return ac;
      }, {}),
    });
  };

  const handleChangeCheckboxMaster = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setAllChecked(event.target.checked);
  };
  useEffect(() => {
    setAllChecked(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  useEffect(() => {
    if (Object.keys(checked).every(key => checked[key]?.['checked'] === true)) {
      setMasterChecked(true);
    } else {
      setMasterChecked(false);
    }
    checkSelected(
      Object.keys(checked)
        .filter(key => checked[key]?.['checked'])
        .map(key => checked[key]['data']),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  useEffect(() => {
    if (clearFlag) {
      setAllChecked(false);
      clearSelectedEquipments(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearFlag]);

  const { t } = useTranslation();

  return (
    <Fragment>
      <Paper className={classes.root}>
        <TableContainer className={classes.container} ref={ref}>
          <Table
            stickyHeader
            aria-label="sticky table"
            size="small"
            padding="none"
          >
            <TableHead>
              <TableRow>
                {checkboxes && (
                  <TableCell>
                    <Checkbox
                      checked={masterChecked}
                      onChange={handleChangeCheckboxMaster}
                    />
                  </TableCell>
                )}
                {columns.map(column => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      marginLeft: column?.marginLeft,
                      marginRight: column?.marginRight,
                      paddingLeft: column?.paddingLeft,
                      paddingRight: column?.paddingRight,
                    }
                    }
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length ? (
                rows.map((row, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                      {checkboxes && (
                        <TableCell>
                          <Checkbox
                            onChange={(e) => handleChangeCheckbox(e, row)}
                            name={row.id.toString()}
                            checked={checked[row.id]?.['checked'] ? true : false}
                          />
                        </TableCell>
                      )}
                      {columns.map(column => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              marginLeft: column?.marginLeft,
                              marginRight: column?.marginRight,
                              paddingLeft: column?.paddingLeft,
                              paddingRight: column?.paddingRight,
                            }}
                          >
                            {column.format && typeof value === 'number'
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={42}>
                    <div style={{ textAlign: 'center' }}>
                      <Typography>{messageEmptyArray}</Typography>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={AppConstants.rowsPerPageOptions}
          count={paginationConfig.total}
          rowsPerPage={paginationConfig.rowsPerPage}
          page={paginationConfig.page - 1}
          onPageChange={handleChangePage}
          component={'div'}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={t('app.common.rowsPerPage')}
          labelDisplayedRows={({ from, to, count }) =>
            paginationCountLabel(
              from,
              to,
              count,
              t('app.common.paginationCountLabel'),
            )
          }
        />
      </Paper>
    </Fragment>
  );
};

export default TableView;
